import { render, staticRenderFns } from "./ControlPenalty.vue?vue&type=template&id=1eb3f1ae&scoped=true"
import script from "./ControlPenalty.vue?vue&type=script&lang=js"
export * from "./ControlPenalty.vue?vue&type=script&lang=js"
import style0 from "./ControlPenalty.vue?vue&type=style&index=0&id=1eb3f1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb3f1ae",
  null
  
)

export default component.exports